// @ts-check
import React from 'react';
import { Page, Row } from 'shared/containers/portal_layout';
import ReferralStepIndicator from './ReferralStepIndicator';
import { injectRouterMatchProps } from 'utils/v3RouteWrapper';
// Have to pull this in and inject it because we were running react-router v2 & v4, which both had a `history` prop,
// but now we're running v3 & v4, and only v4 has a `history` prop.
import { browserHistory } from 'react-router';

const NewReferralWizardWrapper = props => {
  return (
    <Page>
      <Row>
        <ReferralStepIndicator currentStep={props.route.step} />
      </Row>
      {React.createElement(props.route.stepComponent, {
        ...props,
        history: props.history || browserHistory,
      })}
    </Page>
  );
};

export default injectRouterMatchProps(NewReferralWizardWrapper);
